import { put, takeLatest } from 'redux-saga/effects';
import api from '../../../utils/apiConfig';
import UmsActionTypes from './types';
import {
  fetchAllRolesStart,
  fetchOperatorSubordinatesStart,
  fetchOperatorSubordinatesSuccess,
  fetchOperatorSubordinatesFailure,
  deleteOperatorSubordinateFailure,
  fetchAllRolesSuccess,
  fetchAllVehiclesSuccess,
  fetchPermissionSuccess,
  addUserSuccess,
} from './actions';
import { showSnackBar } from '../../../components/UI/HOC/SnackBar/store/actions';
import UrlConfig from './urls';

function* fetchOperatorSubordinates(action: any) {
  const requestURL = UrlConfig.fetchOperatorSubordinates();
  try {
    const response = yield api.get(requestURL);
    if (response.data.success) {
      yield put(fetchOperatorSubordinatesSuccess(response.data.data));
    }
  } catch (e) {
    fetchOperatorSubordinatesFailure(e);
    console.log({ e });
  }
}

function* deleteSubordinate(action: any) {
  const requestURL = UrlConfig.deleteOperatorSubordinate(action.payload);
  try {
    const response = yield api.delete(requestURL);
    if (response.data.success) {
      yield put(showSnackBar({ variant: 'success', message: 'User deleted successfully.' }));
      yield put(fetchOperatorSubordinatesStart());
    } else {
      yield put(deleteOperatorSubordinateFailure(response.data.message));
      yield put(
        showSnackBar({
          variant: 'error',
          message: `${response.data.message}`,
        }),
      );
    }
  } catch (e) {
    yield put(deleteOperatorSubordinateFailure('Something went wrong, try again!'));
    console.log({ e });
  }
}

function* fetchRoles() {
  const requestURL = UrlConfig.fetchAllRoles();
  try {
    const response = yield api.get(requestURL);
    if (response.data.success) {
      yield put(fetchAllRolesSuccess(response.data.data));
    }
  } catch (e) {
    console.log({ e });
  }
}

function* fetchVehicles() {
  const requestURL = UrlConfig.fetchAllVehicles();
  try {
    const response = yield api.get(requestURL);
    if (response.data.success) {
      yield put(fetchAllVehiclesSuccess(response.data.data));
    }
  } catch (e) {
    console.log({ e });
  }
}

function* fetchPermissions() {
  const requestURL = UrlConfig.fetchPermissions();
  try {
    const response = yield api.get(requestURL);
    if (response.data.success) {
      yield put(fetchPermissionSuccess(response.data.data));
    }
  } catch (e) {
    console.log({ e });
  }
}

function* createRole(action: any) {
  const requestURL = UrlConfig.createRole();
  try {
    const response = yield api.post(requestURL, action.payload);
    if (response.data.success) {
      yield put(
        showSnackBar({
          message: 'Role created successfully',
          variant: 'success',
        }),
      );
      yield put(fetchAllRolesStart());
    } else {
      yield put(
        showSnackBar({
          variant: 'error',
          message: `${response.data.message}`,
        }),
      );
    }
  } catch (e) {
    console.log({ e });
  }
}

function* addRole(action: any) {
  const requestURL = UrlConfig.addRole();
  try {
    const response = yield api.post(requestURL, action.payload);
    if (response.data.success) {
      yield put(
        showSnackBar({
          message: 'Role added successfully',
          variant: 'success',
        }),
      );
      yield put(fetchAllRolesStart());
    } else {
      yield put(
        showSnackBar({
          variant: 'error',
          message: `${response.data.message}`,
        }),
      );
    }
  } catch (e) {
    console.log({ e });
  }
}

function* deleteRole(action: any) {
  const requestURL = UrlConfig.deleteRole();
  try {
    const response = yield api.post(requestURL, action.payload);
    if (response.data.success) {
      yield put(
        showSnackBar({
          message: 'Role deleted successfully',
          variant: 'success',
        }),
      );
      yield put(fetchAllRolesStart());
    } else {
      yield put(
        showSnackBar({
          variant: 'error',
          message: `${response.data.message}`,
        }),
      );
    }
  } catch (e) {
    console.log({ e });
  }
}

function* addUser(action: any) {
  const requestURL = UrlConfig.addUser();
  try {
    const response = yield api.post(requestURL, action.payload);
    if (response.data.success) {
      yield put(addUserSuccess(response.data.data));
      yield put(
        showSnackBar({
          message: 'User added successfully',
          variant: 'success',
        }),
      );
    } else {
      yield put(
        showSnackBar({
          message: `${response.data.message}`,
          variant: 'error',
        }),
      );
    }
  } catch (e) {
    console.log({ e });
  }
}

function* umsSaga() {
  yield takeLatest(UmsActionTypes.FETCH_OPERATOR_SUBORDINATES_START, fetchOperatorSubordinates);
  yield takeLatest(UmsActionTypes.DELETE_OPERATOR_SUBORDINATE_START, deleteSubordinate);
  yield takeLatest(UmsActionTypes.FETCH_ALL_ROLES_START, fetchRoles);
  yield takeLatest(UmsActionTypes.FETCH_ALL_VEHICLES_START, fetchVehicles);
  yield takeLatest(UmsActionTypes.FETCH_PERMISSION_START, fetchPermissions);
  yield takeLatest(UmsActionTypes.CREATE_ROLE_START, createRole);
  yield takeLatest(UmsActionTypes.ADD_ROLE_START, addRole);
  yield takeLatest(UmsActionTypes.DELETE_ROLE_START, deleteRole);
  yield takeLatest(UmsActionTypes.ADD_USER_START, addUser);
}
export default umsSaga;
